import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardBody, CardHeader } from '../components/ui/Card';
import { CreditCard, ShieldCheck, FileText, CheckCircle2, Info } from 'lucide-react';
export function Pricing() {
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-817">
      {/* Header */}
      <div className="bg-primary-900 text-white py-16" data-id="element-818">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-819">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-820">
            Pricing & Insurance
          </h1>
          <p className="text-xl text-primary-100 max-w-3xl mx-auto" data-id="element-821">
            Transparent pricing with no hidden fees. We work with various
            insurance providers and offer flexible payment options to make
            transportation accessible.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8" data-id="element-822">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-823">
          {/* Base Rates */}
          <Card className="shadow-lg border-none lg:col-span-2" data-id="element-824">
            <CardHeader className="bg-white border-b border-warm-200 py-6" data-id="element-825">
              <h2 className="text-2xl font-bold text-warm-900 flex items-center" data-id="element-826">
                <CreditCard className="w-6 h-6 mr-3 text-primary-600" data-id="element-827" />
                Private Pay Rates
              </h2>
            </CardHeader>
            <CardBody className="p-8" data-id="element-828">
              <p className="text-warm-600 mb-8 text-lg" data-id="element-829">
                Our rates are calculated based on a base pickup fee plus
                mileage. The level of assistance required determines the base
                rate.
              </p>

              <div className="space-y-8" data-id="element-830">
                <div className="bg-warm-50 rounded-xl p-6 border border-warm-200" data-id="element-831">
                  <div className="flex justify-between items-start mb-4" data-id="element-832">
                    <div data-id="element-833">
                      <h3 className="text-xl font-bold text-warm-900" data-id="element-834">
                        Ambulatory Service
                      </h3>
                      <p className="text-warm-600 text-sm" data-id="element-835">
                        For passengers who can walk with or without a
                        cane/walker.
                      </p>
                    </div>
                    <div className="text-right" data-id="element-836">
                      <span className="block text-2xl font-bold text-primary-700" data-id="element-837">
                        $45
                      </span>
                      <span className="text-sm text-warm-500" data-id="element-838">Base Rate</span>
                    </div>
                  </div>
                  <div className="flex items-center text-warm-700 font-medium mb-5" data-id="element-839">
                    <span className="bg-white px-3 py-1 rounded-md border border-warm-200 mr-3" data-id="element-840">
                      + $3.00
                    </span>{' '}
                    per mile
                  </div>
                  <div className="flex gap-3 items-stretch" data-id="element-841">
                    <Link to="/booking?service=ambulatory" className="flex-1 flex" data-id="element-842">
                      <Button variant="primary" size="sm" className="w-full h-full" data-id="element-843">
                        Call Now
                      </Button>
                    </Link>
                    <Link to="/booking?service=ambulatory" className="flex-1 flex" data-id="element-844">
                      <Button variant="outline" size="sm" className="w-full h-full border-2" data-id="element-845">
                        Get a Quote
                      </Button>
                    </Link>
                  </div>
                </div>

                <div className="bg-primary-50 rounded-xl p-6 border border-primary-200 relative overflow-hidden" data-id="element-846">
                  <div className="absolute top-0 right-0 bg-primary-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-847">
                    Most Common
                  </div>
                  <div className="flex justify-between items-start mb-4" data-id="element-848">
                    <div data-id="element-849">
                      <h3 className="text-xl font-bold text-primary-900" data-id="element-850">
                        Wheelchair Service
                      </h3>
                      <p className="text-primary-700 text-sm" data-id="element-851">
                        For passengers requiring a wheelchair lift and
                        securement.
                      </p>
                    </div>
                    <div className="text-right" data-id="element-852">
                      <span className="block text-2xl font-bold text-primary-700" data-id="element-853">
                        $75
                      </span>
                      <span className="text-sm text-primary-600" data-id="element-854">
                        Base Rate
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center text-primary-800 font-medium mb-5" data-id="element-855">
                    <span className="bg-white px-3 py-1 rounded-md border border-primary-200 mr-3" data-id="element-856">
                      + $4.00
                    </span>{' '}
                    per mile
                  </div>
                  <div className="flex gap-3 items-stretch" data-id="element-857">
                    <Link to="/booking?service=wheelchair" className="flex-1 flex" data-id="element-858">
                      <Button variant="primary" size="sm" className="w-full h-full" data-id="element-859">
                        Call Now
                      </Button>
                    </Link>
                    <Link to="/booking?service=wheelchair" className="flex-1 flex" data-id="element-860">
                      <Button variant="outline" size="sm" className="w-full h-full border-2" data-id="element-861">
                        Get a Quote
                      </Button>
                    </Link>
                  </div>
                </div>

                <div className="bg-warm-50 rounded-xl p-6 border border-warm-200" data-id="element-862">
                  <div className="flex justify-between items-start mb-4" data-id="element-863">
                    <div data-id="element-864">
                      <h3 className="text-xl font-bold text-warm-900" data-id="element-865">
                        Wait Time (Optional)
                      </h3>
                      <p className="text-warm-600 text-sm" data-id="element-866">
                        Driver waits at the destination for the return trip.
                      </p>
                    </div>
                    <div className="text-right" data-id="element-867">
                      <span className="block text-2xl font-bold text-primary-700" data-id="element-868">
                        $40
                      </span>
                      <span className="text-sm text-warm-500" data-id="element-869">Per Hour</span>
                    </div>
                  </div>
                  <p className="text-sm text-warm-500 italic mb-5" data-id="element-870">
                    Billed in 15-minute increments after the first 15 minutes
                    (grace period).
                  </p>
                  <div className="flex gap-3 items-stretch" data-id="element-871">
                    <Link to="/booking" className="flex-1 flex" data-id="element-872">
                      <Button variant="primary" size="sm" className="w-full h-full" data-id="element-873">
                        Call Now
                      </Button>
                    </Link>
                    <Link to="/booking" className="flex-1 flex" data-id="element-874">
                      <Button variant="outline" size="sm" className="w-full h-full border-2" data-id="element-875">
                        Get a Quote
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg flex items-start" data-id="element-876">
                <Info className="w-5 h-5 text-yellow-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-877" />
                <p className="text-sm text-yellow-800" data-id="element-878">
                  <strong data-id="element-879">Note:</strong> Additional fees may apply for
                  after-hours service (8 PM - 6 AM), weekends, holidays, or
                  trips requiring two-person assistance (e.g., bariatric
                  transport or stairs).
                </p>
              </div>
            </CardBody>
          </Card>

          {/* Insurance & Payment Info */}
          <div className="space-y-8" data-id="element-880">
            <Card className="shadow-lg border-none bg-white" data-id="element-881">
              <CardBody className="p-8" data-id="element-882">
                <ShieldCheck className="w-10 h-10 text-primary-600 mb-4" data-id="element-883" />
                <h3 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-884">
                  Insurance &amp; Medicaid
                </h3>
                <p className="text-warm-700 mb-6 leading-relaxed" data-id="element-885">
                  We are an approved Non-Emergency Medical Transportation (NEMT)
                  provider for several networks.
                </p>
                <ul className="space-y-3 mb-6" data-id="element-886">
                  <li className="flex items-center" data-id="element-887">
                    <CheckCircle2 className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" data-id="element-888" />
                    <span className="text-warm-900 font-medium" data-id="element-889">
                      State Medicaid Programs
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-890">
                    <CheckCircle2 className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" data-id="element-891" />
                    <span className="text-warm-900 font-medium" data-id="element-892">
                      Medicare Advantage Plans
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-893">
                    <CheckCircle2 className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" data-id="element-894" />
                    <span className="text-warm-900 font-medium" data-id="element-895">
                      Worker's Compensation
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-896">
                    <CheckCircle2 className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" data-id="element-897" />
                    <span className="text-warm-900 font-medium" data-id="element-898">
                      VA Benefits (Pre-authorized)
                    </span>
                  </li>
                </ul>
                <div className="bg-warm-50 rounded-lg p-4 border border-warm-200" data-id="element-899">
                  <p className="text-sm text-warm-700 leading-relaxed" data-id="element-900">
                    <strong className="text-primary-700 block mb-1" data-id="element-901">
                      Important Note:
                    </strong>
                    Prior authorization is usually required. Please contact your
                    insurance coordinator or call us for assistance.
                  </p>
                </div>
                <div className="mt-6" data-id="element-902">
                  <a href="tel:5551234567" data-id="element-903">
                    <Button size="sm" variant="primary" className="w-full" data-id="element-904">
                      Call for Insurance Help
                    </Button>
                  </a>
                </div>
              </CardBody>
            </Card>

            <Card className="shadow-lg border-none" data-id="element-905">
              <CardBody className="p-8" data-id="element-906">
                <FileText className="w-10 h-10 text-primary-600 mb-4" data-id="element-907" />
                <h3 className="text-xl font-bold text-warm-900 mb-4" data-id="element-908">
                  Accepted Payment Methods
                </h3>
                <p className="text-warm-600 mb-6" data-id="element-909">
                  For private pay clients, we require a credit card on file to
                  secure the reservation. Payment is processed after the trip is
                  completed.
                </p>
                <div className="flex flex-wrap gap-3" data-id="element-910">
                  <span className="px-3 py-1 bg-warm-100 text-warm-800 rounded-md text-sm font-medium border border-warm-200" data-id="element-911">
                    Visa
                  </span>
                  <span className="px-3 py-1 bg-warm-100 text-warm-800 rounded-md text-sm font-medium border border-warm-200" data-id="element-912">
                    Mastercard
                  </span>
                  <span className="px-3 py-1 bg-warm-100 text-warm-800 rounded-md text-sm font-medium border border-warm-200" data-id="element-913">
                    Amex
                  </span>
                  <span className="px-3 py-1 bg-warm-100 text-warm-800 rounded-md text-sm font-medium border border-warm-200" data-id="element-914">
                    Discover
                  </span>
                  <span className="px-3 py-1 bg-warm-100 text-warm-800 rounded-md text-sm font-medium border border-warm-200" data-id="element-915">
                    FSA/HSA Cards
                  </span>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-916">
          <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-917">
            Need a specific quote?
          </h2>
          <p className="text-warm-600 mb-8" data-id="element-918">
            Every trip is unique. For an accurate estimate based on your exact
            pickup and drop-off locations, please contact our dispatch team or
            use our booking form.
          </p>
          <div className="flex justify-center gap-4" data-id="element-919">
            <Link to="/booking" data-id="element-920">
              <Button size="lg" data-id="element-921">Get a Quote / Book</Button>
            </Link>
            <a href="tel:5551234567" data-id="element-922">
              <Button size="lg" variant="outline" data-id="element-923">
                Call (555) 123-4567
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>;
}